import { createReducer, on } from '@ngrx/store';
import { SessionState, initialSessionState } from '../state/session.state';
import {
  setParticipantId,
  loadSession,
  loadSessionSuccess,
  loadSessionFailure,
  initializeSession,
  initializeSessionSuccess,
  initializeSessionFailure,
  clearSession,
  setSigningJoinCode,
  setCurrentDocumentIndex,
  receiveSigningStatusUpdate,
  receiveParticipantStatusUpdate,
  flagSessionCanceled,
} from '../actions/session.actions';

export const sessionReducer = createReducer(
  initialSessionState,
  on(
    setParticipantId,
    (state, { participantId }): SessionState => ({
      ...state,
      participantId,
    }),
  ),
  on(
    loadSession,
    (state): SessionState => ({
      ...state,
      participant: null,
      signing: null,
      isLoading: true,
      error: null,
    }),
  ),
  on(
    loadSessionSuccess,
    (state, { participant, signing }): SessionState => ({
      ...state,
      participant,
      signing,
      isLoading: false,
      error: null,
    }),
  ),
  on(
    loadSessionFailure,
    (state, { error }): SessionState => ({
      ...state,
      isLoading: false,
      error,
    }),
  ),
  on(
    initializeSession,
    (state): SessionState => ({
      ...state,
      isLoading: true,
      error: null,
    }),
  ),
  on(
    initializeSessionSuccess,
    (state, { sessionId }): SessionState => ({
      ...state,
      sessionId,
      isLoading: false,
      error: null,
    }),
  ),
  on(
    initializeSessionFailure,
    (state, { error }): SessionState => ({
      ...state,
      isLoading: false,
      error,
    }),
  ),
  on(
    setCurrentDocumentIndex,
    (state, { index }): SessionState => ({
      ...state,
      currentDocumentIndex: index,
    }),
  ),
  on(
    clearSession,
    (state): SessionState => ({
      ...state,
      sessionId: null,
    }),
  ),
  on(
    setSigningJoinCode,
    (state, { joinCode }): SessionState => ({
      ...state,
      signingJoinCode: joinCode,
    }),
  ),
  on(
    receiveSigningStatusUpdate,
    (state, { update }): SessionState => ({
      ...state,
      signingStatusUpdates: {
        ...state.signingStatusUpdates,
        [update.participantId]: update,
      },
    }),
  ),
  on(
    receiveParticipantStatusUpdate,
    (state, { update }): SessionState => ({
      ...state,
      participantStatusUpdates: {
        ...state.participantStatusUpdates,
        [update.participantId]: update,
      },
    }),
  ),
  on(
    flagSessionCanceled,
    (state, { reason }): SessionState => ({
      ...state,
      sessionCancellationReason: reason,
    }),
  ),
);
